import OfferFile from "./OfferFile";
import QuestionTemplate from "./QuestionTemplate";
import { SignedFileDataType } from "./SignedFileDataType";

export class OfferTemplate {
  constructor({
    id = NaN,
    title = "",
    dateCreated = new Date(),
    dateUpdated = new Date(),
    organization = NaN,
    offerType = "",
    signedFileDatatype = null,
    description = "",
    isSequential = false,
    files = [],
    signedFileStd = null,
  } = {}) {
    this.id = id;
    this.title = title;
    this.dateCreated = new Date(dateCreated);
    this.dateUpdated = new Date(dateUpdated);
    this.organization = organization;
    this.offerType = offerType;
    this.description = description;
    this.isSequential = isSequential;
    this.signedFileStd = signedFileStd
      ? new QuestionTemplate(signedFileStd)
      : null;
    this.files = files.length ? files.map((file) => new OfferFile(file)) : [];
    this.signedFileDatatype = signedFileDatatype
      ? new SignedFileDataType(signedFileDatatype)
      : null;
  }
}
